import React from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';

const RecentInterviewsList = ({ interviews, onViewResults }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Recent Interviews
        </h3>
        <Button variant="ghost" size="sm" iconName="History" iconPosition="left">
          View All
        </Button>
      </div>
      <div className="space-y-3">
        {interviews?.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-sm text-muted-foreground">
              No interviews yet. Start your first practice session!
            </p>
          </div>
        ) : (
          interviews?.map((interview) => (
            <div 
              key={interview?.id}
              className="flex items-center gap-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors duration-150 ease-out cursor-pointer"
              onClick={() => onViewResults(interview?.id)}
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                interview?.type === 'technical' ? 'bg-primary/10' : 'bg-secondary/10'
              }`}>
                <Icon 
                  name={interview?.type === 'technical' ? 'Code' : 'MessageSquare'} 
                  size={20} 
                  color={interview?.type === 'technical' ? 'var(--color-primary)' : 'var(--color-secondary)'} 
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-sm font-medium text-foreground truncate">
                    {interview?.title}
                  </h4>
                  {interview?.completed && (
                    <Icon name="CheckCircle2" size={14} color="var(--color-success)" />
                  )}
                </div>
                <p className="text-xs text-muted-foreground">
                  {formatDate(interview?.date)}
                </p>
              </div>

              {interview?.score !== null && (
                <div className="text-right">
                  <div className={`text-lg font-semibold ${getScoreColor(interview?.score)}`}>
                    {interview?.score}%
                  </div>
                  <div className="text-xs text-muted-foreground">Score</div>
                </div>
              )}

              <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentInterviewsList;